<button
    [matMenuTriggerFor]="langMenu"
    class="selecor-button"
    [class.has-label]="showLabel"
    mat-icon-button
    [disabled]="isDisabled || isLoading"
    [class.disabled]="isDisabled">
    <lucide-icon
        *ngIf="useGlobeIcon"
        name="globe"
        [size]="showLabel ? 18 : 24"
        class="globe"
    ></lucide-icon>
    <mat-icon
        *ngIf="!useGlobeIcon"
        class="flag"
        [svgIcon]="getFlagCodeFromLocale(selectedLanguage)"
    ></mat-icon>
    <ng-container *ngIf="showLabel">
        <span class="lang-label">{{ 'languages.' + selectedLanguage | translate }}</span>
        <lucide-icon name="chevron-down" [size]="16" class="lang-chevron"></lucide-icon>
    </ng-container>
</button>
<mat-menu #langMenu="matMenu">
    <div *ngFor="let language of availableLanguages">
        <button 
            mat-menu-item 
            (click)="selectLanguage(language.code)"
            [disabled]="isDisabled">
            <div class="menu">
                <mat-icon
                    class="flag"
                    [svgIcon]="getFlagCodeFromLocale(language.code)"
                ></mat-icon>
                <span>
                    {{ 'languages.' + language.code | translate }}
                </span>
            </div>
        </button>
    </div>
</mat-menu>
